import { defineStore } from 'pinia'
import { Environment } from '@/enums'

interface EnvironmentState {
  currentEnv: Environment
}

export const useEnvironmentStore = defineStore({
  id: 'environment',
  state: (): EnvironmentState => ({
    currentEnv: Environment.Production,
  }),
  getters: {
    getCurrentEnv: (state): Environment => state.currentEnv,
    isDevelopment: (state): boolean => state.currentEnv === Environment.Development,
    isProduction: (state): boolean => state.currentEnv === Environment.Production,
    isUAT: (state): boolean => state.currentEnv === Environment.UAT,
    buildTime: (): string => __BUILD_TIME__,
    commitMessage: (): string => __COMMIT_MESSAGE__,
  },
  actions: {
    setEnvironment() {
      const env = import.meta.env.MODE as string
      switch (env) {
        case 'development':
          this.currentEnv = Environment.Development
          break
        case 'localdev':
          this.currentEnv = Environment.Development
          break
        case 'uat':
          this.currentEnv = Environment.UAT
          break
        default:
          this.currentEnv = Environment.Production
      }
    },
  },
  persist: true,
})
